export interface IWarehouseShopProductBuildingData {
    history_90_days?: number|string;
    history_365_days?: number|string;
    suggested?: number|string;
    min_stock?: null|number|string;
    max_stock?: null|number|string;
    last_stock_count?: number|string;
    last_stock_count_on?: null|string;
    last_stock_count_by?: null|string;
    pending_order_amount?: number|string;
    disabled?: boolean|number|string;
    rack?: null|string;
    layer?: null|string;
}

export interface IWarehouseShopProductData {
    id: number;
    name: string;
    description?: null|string;
    category?: null|number|string;
    type?: null|number|string;
    active?: boolean|number|string;
    retour?: boolean|number|string;
    units_per_package?: number|string;
    image?: null|string;
    thumb?: null|string;
    image_timestamp?: null|string;
    thumbnailUrl?: null|string;
    imageUrl?: null|string;
    building?: IWarehouseShopProductBuildingData;
}

function nullableNumber(value: null|undefined|number|string): null|number {
    if (value === null || value === undefined || value === "") return null;

    const parsed = Number(value);

    return Number.isFinite(parsed) ? parsed : null;
}

function booleanValue(value: boolean|number|string|undefined): boolean {
    if (value === undefined) return false;
    if (typeof value === "boolean") return value;
    if (typeof value === "number") return value === 1;

    return value === "1" || value.toLowerCase() === "true";
}

export default class WarehouseShopProductData {
    public id: number;
    public name: string;
    public description: null|string;
    public category: null|number;
    public type: null|number;
    public active: boolean;
    public retour: boolean;
    public units_per_package: number;
    public image: null|string;
    public thumb: null|string;
    public image_timestamp: null|string;
    public thumbnailUrl: null|string;
    public imageUrl: null|string;

    public history_90_days: number;
    public history_365_days: number;
    public suggested: number;
    public min_stock: null|number;
    public max_stock: null|number;
    public last_stock_count: number;
    public last_stock_count_on: null|string;
    public last_stock_count_by: null|string;
    public pending_order_amount: number;
    public disabled: boolean;
    public rack: null|string;
    public layer: null|string;

    constructor(data: IWarehouseShopProductData) {
        const building = data.building ?? {};
        const unitsPerPackage = nullableNumber(data.units_per_package);

        this.id = Number(data.id);
        this.name = data.name;
        this.description = data.description ?? null;
        this.category = nullableNumber(data.category);
        this.type = nullableNumber(data.type);
        this.active = booleanValue(data.active);
        this.retour = booleanValue(data.retour);
        this.units_per_package = Math.max(1, unitsPerPackage ?? 1);
        this.image = data.image ?? null;
        this.thumb = data.thumb ?? null;
        this.image_timestamp = data.image_timestamp ?? null;
        this.thumbnailUrl = data.thumbnailUrl ?? null;
        this.imageUrl = data.imageUrl ?? null;

        this.history_90_days = Number(building.history_90_days ?? 0);
        this.history_365_days = Number(building.history_365_days ?? 0);
        this.suggested = Number(building.suggested ?? 0);
        this.min_stock = nullableNumber(building.min_stock);
        this.max_stock = nullableNumber(building.max_stock);
        this.last_stock_count = Number(building.last_stock_count ?? 0);
        this.last_stock_count_on = building.last_stock_count_on ?? null;
        this.last_stock_count_by = building.last_stock_count_by ?? null;
        this.pending_order_amount = Number(building.pending_order_amount ?? 0);
        this.disabled = booleanValue(building.disabled);
        this.rack = building.rack ?? null;
        this.layer = building.layer ?? null;
    }

    public get available(): boolean {
        return this.active && !this.disabled;
    }
}